import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsString, MaxLength } from 'class-validator'

/**
 * DTO pour rechercher les chapitres liés à un enseignement
 */
export class SearchTeachingChaptersDto {
  @ApiPropertyOptional({
    type: 'string',
    description: 'Terme de recherche sur le titre du chapitre',
    example: 'Équations',
    maxLength: 255,
  })
  @IsOptional()
  @IsString()
  @MaxLength(255, {
    message: 'Le terme de recherche ne peut pas dépasser 255 caractères',
  })
  q?: string
}
